export default "__VITE_ASSET__DoCcN0po__"